module.exports = __webpack_public_path__ + "static/media/cardio1-old.6d22e282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/program_categories/cardio1-old.jpg
// module id = 1569
// module chunks = 0